'use strict';

var object = require('../../object');
var Transport = require('../../transport');
var Event = require('./event');
var dom = require('./dom');
var hash = require('../hash');

var transport = new Transport('/action_tracker');

module.exports = function(domainUid, jsHitId, intention, eventData, opt_context, opt_lastReq, instance_id) {
  if (!intention) {
    throw new Error('Bad intention: ' + intention);
  }

  var now = new Date();
  var event = new Event(eventData);
  var action = {
    'context': opt_context || null,
    'event': {
      'is_custom': event.isCustomEvent,
      'type': event.getType(),
      'offsetX': event.offsetX,
      'offsetY': event.offsetY,
      'clientX': event.clientX,
      'clientY': event.clientY,
      'screenX': event.screenX,
      'screenY': event.screenY,
      'button': event.button,
      'target_path': dom.getPath(event.target, event.currentTarget),
    },
    'intention': intention,
    'viewport': {
      'scroll': dom.getViewportScroll(),
      'size': dom.getViewportSize(),
    },
    'domain_uid': domainUid,
    'js_hit_id': jsHitId,
    'action_id': hash.guid(),
    'pagetype': opt_lastReq && opt_lastReq.pagetype || null
  };
  transport.send({
    'action_id': action['action_id'],
    'domain_uid': domainUid,
    'js_hit_id': jsHitId,
    'funnel_instance_id': instance_id
  }, action);
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/trackaction/index.js
// module id = 23
// module chunks = 1 3